const moment = require("moment");
const utils = require("Sources/utils/utils");

module.exports = class GroupPurchase
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.key = options.key;
    this.comment = options.comment;
    this.invoiceDate = options["invoice-date"];
  }

  set invoiceDate(date)
  {
    this._invoiceDate = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get invoiceDate()
  {
    return utils.isMomentObject(this._invoiceDate) ? this._invoiceDate.format("DD-MM-YYYY") : null;
  }
}



// WEBPACK FOOTER //
// ./app/js/models/admin/group-purchase.js